import { Params } from '@angular/router';
import { LicenseType } from 'mbs-ui-shared@models';
import BrandLicense from 'mbs-ui-shared@models/BrandLicense';
import { AdministratorLicense } from 'mbs-ui-shared@models/License';
import { License } from 'mbs-ui-shared@models/licenses/License';

export class LicensesHelper {
  public static IsLicenseExpired(license: License): boolean {
    const now = new Date();
    return now > new Date(license.dateExpired);
  }
  public static isLicenseExpiresAfterManyYears(license: License | BrandLicense | AdministratorLicense): boolean {
    const manyYears = 9000;
    const expiredDate = new Date(license.dateExpired);

    return expiredDate.getFullYear() > manyYears;
  }

  public static getQueryParamsForCalculator(license: LicenseType, hid: string): Params {
    const licenseTypes = {
      [LicenseType.MSSQL]: 'sql',
      [LicenseType.Exchange]: 'exchage',
      [LicenseType.BareMetal]: 'baremetal',
      [LicenseType.OnlyDesktop]: 'desktop',
      [LicenseType.VirtualMachine]: 'vm',
      [LicenseType.VirtualMachineSocket]: 'vmsocket',
      [LicenseType.Ultimate]: 'ultimate',
      [LicenseType.RemoteDesktop]: 'rd',
      [LicenseType.RMM]: 'rmm',
      [LicenseType.DeepInstinct]: 'deepinst',
      [LicenseType["Advanced Rebranding & Custom SSL"]]: 'rebranding',
      [LicenseType.PremiumSupport]: 'PremiumSupport',
    };

    return {
      buy: 'true',
      licenses: licenseTypes[license] || '',
      assign: hid ? `${hid}:${license}` : null
    };
  }
}
